export const FED_TAX_ID = "federalTaxId";
export const STATE_TAX_ID = "stateTaxId";
export const CAM_LICENSE_NO = "camLicenseNumber";
export const CAM_LICENSE_START_DATE = "camLicenseStartDate";
export const CAM_LICENSE_END_DATE = "camLicenseEndDate";
export const LAST_AGM_DATE = "lastAgmDate";
export const FILLING_DUE_DATE = "annualFilingDueDate";

export const formatFederalTaxId = (value: string) => {
  value = value.replace(/[^A-Z0-9]/g, ""); // Allow only uppercase letters & numbers
  if (value.length > 2) {
    return (
      value.slice(0, 3) + "-" + value.slice(3, 5) + "-" + value.slice(5, 9)
    ); // Insert '-' at index 2
  }
  return value;
};
